import { Card, Tag } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import tw from "tailwind-styled-components";
import PageTitle from "../page-header/PageHeader";
import Loader from "../loader/loader";

const DetailMeeting = () => {
	const { id } = useParams();
	const [meeting, setMeeting] = useState(null);
	const [loading, setLoading] = useState(true);
	const isLogged = Boolean(localStorage.getItem("isLogged"));

	useEffect(() => {
		// Get meetings from localStorage
		const storedMeetings = localStorage.getItem("meetings");
		if (storedMeetings) {
			try {
				const meetings = JSON.parse(storedMeetings);
				const meetingId = parseInt(id);
				const foundMeeting = meetings.find((m) => m.id === meetingId || String(m.id) === String(id));
				if (foundMeeting) {
					setMeeting(foundMeeting);
				}
			} catch (error) {
				console.error("Error parsing meetings from localStorage:", error);
			}
		}
		setLoading(false);
	}, [id]);

	if (!isLogged) {
		return <Navigate to={"/admin/auth/login"} replace={true} />;
	}

	if (loading) {
		return <Loader />;
	}

	if (!meeting) {
		return (
			<div>
				<PageTitle title="Back" />
				<Card className="mt-4">
					<div className="text-center">
						<h3 className="text-xl text-red-500">Meeting not found</h3>
						<p className="text-gray-600 mt-2">The meeting with ID {id} could not be found.</p>
					</div>
				</Card>
			</div>
		);
	}

	const getStatusColor = (status) => {
		switch (status) {
			case "Completed":
				return "green";
			case "Cancelled":
				return "red";
			case "Postponed":
				return "orange";
			default:
				return "blue";
		}
	};

	return (
		<div>
			<PageTitle title="Back" />
			<Card className="mt-4">
				<div className="text-center mb-4">
					<h2 className="text-2xl font-semibold text-gray-600">
						Meeting #{meeting.id}
					</h2>
				</div>
				{meeting ? (
					<div className="flex justify-center">
						<ul className="list-inside list-none border-2 border-inherit rounded px-5 py-5">
							<ListItem>
								Manager:{" "}
								<TextInside>{meeting.managerName || "N/A"}</TextInside>
							</ListItem>
							<ListItem>
								Employee:{" "}
								<TextInside>{meeting.employeeName || "N/A"}</TextInside>
							</ListItem>
							<ListItem>
								Meeting Date:{" "}
								<TextInside>
									{meeting.meetingDate
										? dayjs(meeting.meetingDate).format("DD-MM-YYYY")
										: "N/A"}
								</TextInside>
							</ListItem>
							<ListItem>
								Meeting Time:{" "}
								<TextInside>{meeting.meetingTime || "N/A"}</TextInside>
							</ListItem>
							<ListItem>
								Location:{" "}
								<TextInside>{meeting.location || "N/A"}</TextInside>
							</ListItem>
							<ListItem>
								Agenda:{" "}
								<TextInside>{meeting.agenda || "N/A"}</TextInside>
							</ListItem>
							{meeting.notes && (
								<ListItem>
									Notes:{" "}
									<TextInside>{meeting.notes}</TextInside>
								</ListItem>
							)}
							<ListItem>
								Status:{" "}
								<TextInside>
									<Tag color={getStatusColor(meeting.status)}>
										{meeting.status || "Scheduled"}
									</Tag>
								</TextInside>
							</ListItem>
						</ul>
					</div>
				) : (
					<Loader />
				)}
			</Card>
		</div>
	);
};

const ListItem = tw.li`
	text-sm
	text-gray-600
	font-semibold
	py-2
	px-4
	bg-gray-100
	mb-1.5
	rounded
	w-96
	flex
	justify-start
`;

const TextInside = tw.p`
	ml-2
	text-sm
	text-gray-900
`;

export default DetailMeeting;

